var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TwitterLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2927 11.0229C16.2927 8.27292 18.6052 5.98542 21.3552 6.02292C22.3182 6.03403 23.2576 6.32306 24.0603 6.85526C24.863 7.38746 25.495 8.14017 25.8802 9.02292H30.2927L26.2552 13.0604C25.9946 17.1161 24.1993 20.9204 21.2342 23.6997C18.269 26.4791 14.3567 28.0249 10.2927 28.0229C6.29267 28.0229 5.29267 26.5229 5.29267 26.5229C5.29267 26.5229 9.29267 25.0229 11.2927 22.0229C11.2927 22.0229 3.29267 18.0229 5.29267 7.02292C5.29267 7.02292 10.2927 12.0229 16.2927 13.0229V11.0229Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/TwitterLogo.5a8971faeae1adaa282f207440575ae5.svg";
export { ForwardRef as ReactComponent };